import { render, staticRenderFns } from "./CookieInfo.vue?vue&type=template&id=33482439&lang=pug"
import script from "./CookieInfo.vue?vue&type=script&lang=js"
export * from "./CookieInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports